import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const featured = articles.find((a) => a.slug === 'duli-baoliao-yule-gongsi');
  const hot = articles.filter((a) => a.isHot && a.slug !== 'duli-baoliao-yule-gongsi').slice(0, 3);
  const rest = articles.filter((a) => !a.isHot || (a.isHot && a.slug === 'duli-baoliao-yule-gongsi')).slice(1, 7);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      {/* Section Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新爆料
          </h2>
          <p className="text-sm text-foreground-600 mt-1">
            实时更新，不错过任何一个瓜
          </p>
        </div>
        <a
          href="/"
          className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
        >
          查看全部
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </a>
      </div>

      {/* Featured Article */}
      {featured && (
        <div className="mb-8">
          <ArticleCard article={featured} variant="featured" />
        </div>
      )}

      {/* Hot Articles Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
        {hot.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>

      {/* Rest Articles */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {rest.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}